import { httpInstancePaymentLink } from '../httpInstance';

const deletePaymentLinkMerchantService = async (linkId) => {
  let res;
  const endpoint = `/PaymentLinks/${linkId}`;
  await httpInstancePaymentLink.delete(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default deletePaymentLinkMerchantService;
